<template>
	<div class="About">
		<div class="pr">
			<!-- <img :src="require('../assets/About_banner_'+routerTab+'.jpg')" class="w100" /> -->
			<el-image style="width: 100%;" :style="{'height': $store.state.mobile ? '220px':'360px'}" :src="require('../assets/About_banner_GSJJ.jpg')" :fit="'cover'"></el-image>
			<div class="pa tz t0 w100 banner">
				<img src="../assets/About.png" />
			</div>
		</div>
		<div class="tz borb1 hidden-xs-only" style="background-color: #f2f5f7;">
			<div class="dib tabs" @mouseleave="activeTab = routerTab">
				<el-tabs v-model="activeTab">
					<template v-for="item in tabs">
						<el-tab-pane :name="item.tab">
							<template #label>
								<div class="tab" @mouseenter="mousemove(item.tab)" @click="link(item.tab)">{{item.name}}
								</div>
							</template>
						</el-tab-pane>
					</template>
				</el-tabs>
			</div>
		</div>
		<router-view />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeTab: 'GSJJ',
				routerTab: 'GSJJ',
				tabs: [{
					name: '公司简介',
					tab: 'GSJJ'
				}, {
					name: '发展历程',
					tab: 'FZLC'
				}, {
					name: '业务板块',
					tab: 'YWBK'
				}, {
					name: '组织机构',
					tab: 'ZZJG'
				}, {
					name: '服务理念',
					tab: 'FWLN'
				}, {
					name: '资质荣誉',
					tab: 'ZZRY'
				}, {
					name: '企业优势',
					tab: 'QYYS'
				}]
			}
		},
		watch: {
			'$store.state.link'() {
				this.$nextTick(() => { //页面加载完成后执行
					this.initTab();
				})
			}
		},
		mounted() {
			this.initTab();
		},
		methods: {
			initTab() {
				this.$nextTick(() => {
					this.tabs.forEach(x => {
						if (this.$route.href.includes(x.tab)) {
							this.routerTab = this.activeTab = x.tab
						}
					})
				})
			},
			mousemove(activeTab) {
				this.activeTab = activeTab
			},
			link(tab) {
				this.routerTab = tab;
				this.$router.push({
					name: tab
				})
			}
		}
	}
</script>

<style lang="scss">
	.About {
		.banner {
			margin-top: 120px;
			@media screen and (max-width: 768px) {
				margin-top: 0;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
		.el-tabs__nav-wrap {
			&::after {
				display: none;
			}

			.tab {
				font-size: 16px;
				color: #333333;
				line-height: 40px;
				cursor: pointer;
			}
		}

		.el-tabs__item {
			padding: 0 55px;
			position: relative;

			&::after {
				position: absolute;
				content: ' ';
				width: 1px;
				height: 15px;
				background-color: #444;
				right: 0;
				top: 12px;
			}

			&:last-of-type {
				&::after {
					display: none;
				}
			}

			&:hover {
				cursor: default;
			}
		}

		.el-tabs__header {
			margin: 0;
		}

		.tabs {
			margin: 10px 0;
		}
	}
</style>
